export default __webpack_public_path__ + "static/media/services_transport.1f0fa60d.jpg";